"use strict";

define('rs/models/organization',['rs/models/abstract', 'rs/models/person', 'rs/helper'], function (AbstractModel, RSPersonModel, helper) {
  var Organization = AbstractModel.extend({
    properties: ['activityDate', 'approvers', 'organizations', 'updateUser', 'erpId', 'preferredAddress', 'preferredPhone', 'orgType', 'orgTypeId', 'organizationType'],
    serverProperties: ['addresses', 'id', 'parentId', 'phones', 'title', 'titleShort', 'version'],
    initialize: function initialize() {
      this.listenTo(this, 'change:addresses', this.loadPreferredAddress);
      this.listenTo(this, 'change:phones', this.loadPreferredPhoneNumber);
      this._super.apply(this, arguments);
      this.setAddresses(this.addresses || []);
      this.setPhones(this.phones || []);
      this.setOrganizations(this.organizations || []);
    },
    loadPreferredAddress: function loadPreferredAddress() {
      var addresses = this.getAddresses() || [],
        primary = null;
      primary = _.find(addresses, function (address, index, list) {
        return address.preferred == true || list.length == 1 || index == list.length - 1;
      });
      this.setPreferredAddress(primary);
    },
    loadPreferredPhoneNumber: function loadPreferredPhoneNumber() {
      var phones = this.getPhones() || [],
        extension = null,
        primary = null;
      primary = _.find(phones, function (phone, index, list) {
        return phone.preferred == true || list.length == 1 || index == list.length - 1;
      });
      if (primary) {
        extension = primary.extension;
        primary = extension ? primary.number + ' ext. ' + extension : primary.number;
      }
      this.setPreferredPhone(primary);
    },
    remove: function remove() {
      return this.constructor.deleteOrganization(this.getId());
    },
    newChildOrganization: function newChildOrganization(data) {
      var that = this;
      data.parentId = this.getId();
      return this.constructor.createOrganization(data).then(function (org) {
        if (org instanceof Organization) {
          that.getOrganizations().push(org);
        }
        return Promise.resolve(org);
      });
    },
    requestApprovers: function requestApprovers() {
      var that = this;
      return this.constructor.requestOrgApprovers(this.getId()).then(function (approvers) {
        that.setApprovers(approvers);
        return approvers;
      });
    },
    requestAssignApprovers: function requestAssignApprovers(personnel) {
      return this.constructor.requestAssignOrgApprovers(this.getId(), personnel);
    },
    requestRemoveApprovers: function requestRemoveApprovers(approvers) {
      return this.constructor.requestRemoveOrgApprovers(this.getId(), approvers);
    },
    requestPersonnel: function requestPersonnel() {
      return this.constructor.requestPersonnel(this.getId());
    },
    requestDetails: function requestDetails() {
      if (this.hasDetails) {
        return Promise.resolve(this);
      } else {
        return this.constructor.requestDetails(this.getId()).then(function (data) {
          this.hasDetails = true;
          this.applyProperties(data);
          return Promise.resolve(this);
        }.proxy(this));
      }
    },
    update: function update(newData) {
      this.hasDetails = false;
      this.applyProperties(newData);
      return this.constructor.updateOrganization(this).bind(this).then(function (data) {
        this.hasDetails = true;
        this.applyProperties(data);
        return data;
      });
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#org(?*query)': function getOrgQuery(data) {
        return this.models(data);
      },
      '#get#org/:id/approver': function getOrg_Id_approver(data) {
        return RSPersonModel.models(data);
      },
      '#get#org/:id/personnel': function getOrg_Id_personnel(data) {
        return RSPersonModel.models(data);
      },
      '#post#org': function postOrg(data) {
        return this.model(data);
      }
    },
    model: function model(data) {
      if (data.children) {
        data.organizations = _.map(data.children, function (item) {
          return Organization.model(item);
        });
        delete data.children;
      }
      return new Organization(data);
    },
    createOrganization: function createOrganization(data) {
      return this.post('org', data, {
        jsonBody: true
      });
    },
    deleteOrganization: function deleteOrganization(id) {
      return this.del('org/' + id);
    },
    getRoot: function getRoot() {
      return new this({
        id: null,
        name: 'Root Organization',
        parentId: null
      });
    },
    requestDetails: function requestDetails(id) {
      return this.get('org/' + id);
    },
    requestOrganizations: function requestOrganizations(options) {
      var params = {},
        that = this;
      if (options.full) {
        params.full = true;
        options.flat ? params.flat = true : null;
      } else {
        params.id = options.id;
      }
      return this.get('org', params);
    },
    requestPersonnel: function requestPersonnel(id) {
      return this.get('org/' + id + '/personnel');
    },
    requestAssignOrgApprovers: function requestAssignOrgApprovers(id, personnel) {
      return this.post('org/' + id + '/approver', personnel, {
        jsonBody: true
      });
    },
    requestRemoveOrgApprovers: function requestRemoveOrgApprovers(id, approvers) {
      return this.del('org/' + id + '/approver', approvers, {
        jsonBody: true
      });
    },
    requestOrgApprovers: function requestOrgApprovers(id) {
      return this.get('org/' + id + '/approver');
    },
    updateOrganization: function updateOrganization(model) {
      return this.put('org/' + model.getId(), model);
    }
  });
  return Organization;
});

